import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1bf76d4d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1bf76d4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf76d4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf76d4d')) {
      api.createRecord('1bf76d4d', component.options)
    } else {
      api.reload('1bf76d4d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1bf76d4d&scoped=true&", function () {
      api.rerender('1bf76d4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/collect/index.vue"
export default component.exports